import React from "react";
import Text from "components/Text";
import Input from "components/Input";
import moment from "moment";
import { Portal } from "react-overlays";
import Button from "components/Button";
import styles from "../PerformanceReview.module.scss";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import ReactDatePickerCommon from "components/ReactDatePickerCommon";
import { parseCalendarDateToLocalDate } from "utils";

export default function Form({
  t,
  handleSubmit,
  errors,
  formData,
  handleOnChange,
  updateDatesValues,
  handleCancel,
  isDisabled,
}) {
  const CalendarContainer = ({ children }) => {
    const el = document.getElementById("calendar-portal");

    return <Portal container={el}>{children}</Portal>;
  };

  const location = useLocation();

  const previewForm = location?.pathname.includes(
    "preview-performance-review-form",
  );

  const selectedDateOfEmployment = parseCalendarDateToLocalDate(
    formData?.dateOfEmployment,
  );
  const selectedLastRaiseDate = parseCalendarDateToLocalDate(
    formData?.lastRaiseDate,
  );
  const selectedProposedIncreaseDate = parseCalendarDateToLocalDate(
    formData?.proposedIncreaseDate,
  );

  return (
    <form
      onSubmit={handleSubmit}
      className={styles["date_wrapper"] + " " + "c-field mb-0 mt-4"}
    >
      <Input
        Title={t("performanceReview.form.employeeName")}
        Type="text"
        Placeholder={t("performanceReview.form.employeeName")}
        Name={"employeeName"}
        HandleChange={handleOnChange}
        Error={errors?.employeeName}
        Value={formData?.employeeName}
        Disabled={isDisabled || previewForm}
        MaxLength="55"
      />
      <Input
        Title={t("performanceReview.form.position")}
        Type="text"
        Placeholder={t("performanceReview.form.position")}
        Name={"position"}
        HandleChange={handleOnChange}
        Error={errors?.position}
        Value={formData?.position}
        Disabled={previewForm}
        MaxLength="55"
      />
      <div className={styles.new_inputdate + " inputdate"}>
        <Text size="13px" weight="400" color="#79869A">
          {t("performanceReview.form.dateOfEmployment")}
        </Text>
        <ReactDatePickerCommon
          dateFormat="dd-MM-yyyy"
          className="c-form-control"
          selected={selectedDateOfEmployment}
          onChange={(e) => updateDatesValues(e, "dateOfEmployment")}
          popperPlacement="bottom-start"
          popperContainer={CalendarContainer}
          disabled={previewForm}
        />
        {errors?.dateOfEmployment && (
          <span className="error-msg"> {errors?.dateOfEmployment} </span>
        )}
      </div>
      <div className="mt-4">
        <Input
          Title={t("performanceReview.form.beginningSalary")}
          Type="text"
          Placeholder={t("performanceReview.form.beginningSalary")}
          Name={"beginningSalary"}
          HandleChange={handleOnChange}
          Error={errors?.beginningSalary}
          Value={formData?.beginningSalary}
          Disabled={previewForm}
          MaxLength="55"
        />
      </div>
      <Input
        Title={t("performanceReview.form.presentSalary")}
        Type="text"
        Placeholder={t("performanceReview.form.presentSalary")}
        Name={"presentSalary"}
        HandleChange={handleOnChange}
        Error={errors?.presentSalary}
        Value={formData?.presentSalary}
        Disabled={previewForm}
        MaxLength="55"
      />
      <Input
        Title={t("performanceReview.form.amountOfLastRaise")}
        Type="text"
        Placeholder={t("performanceReview.form.amountOfLastRaise")}
        Name={"amountOfLastRaise"}
        HandleChange={handleOnChange}
        Error={errors?.amountOfLastRaise}
        Value={formData?.amountOfLastRaise}
        Disabled={previewForm}
        MaxLength="55"
      />
      <div className={styles.new_inputdate + " " + "inputdate"}>
        <Text size="13px" weight="400" color="#79869A">
          {t("performanceReview.form.lastRaiseDate")}
        </Text>
        <ReactDatePickerCommon
          dateFormat="dd-MM-yyyy"
          className="c-form-control"
          selected={selectedLastRaiseDate}
          onChange={(e) => updateDatesValues(e, "lastRaiseDate")}
          popperPlacement="bottom-start"
          popperContainer={CalendarContainer}
          disabled={previewForm}
          maxDate={moment().toDate()}
        />
        {errors?.lastRaiseDate && (
          <span className="error-msg"> {errors?.lastRaiseDate} </span>
        )}
      </div>
      <div className="mt-4">
        <Input
          Title={t("performanceReview.form.proposedIncrease")}
          Type="text"
          Placeholder={t("performanceReview.form.proposedIncrease")}
          Name={"proposedIncrease"}
          HandleChange={handleOnChange}
          Error={errors?.proposedIncrease}
          Value={formData?.proposedIncrease}
          Disabled={isDisabled || previewForm}
          MaxLength="55"
        />
      </div>
      <div className={styles.new_inputdate + " " + "inputdate"}>
        <Text size="13px" weight="400" color="#79869A">
          {t("performanceReview.form.proposedIncreaseDate")}
        </Text>
        <ReactDatePickerCommon
          dateFormat="dd-MM-yyyy"
          className="c-form-control"
          selected={selectedProposedIncreaseDate}
          onChange={(e) => updateDatesValues(e, "proposedIncreaseDate")}
          popperPlacement="bottom-start"
          popperContainer={CalendarContainer}
          disabled={isDisabled || previewForm}
        />
        {errors?.proposedIncreaseDate && (
          <span className="error-msg"> {errors?.proposedIncreaseDate} </span>
        )}
      </div>
      {errors?.ratingValue && (
        <span className="error-msg mt-3">{errors.ratingValue}</span>
      )}
      {!previewForm && (
        <div className={styles.btn_wrapper + " " + styles.margin40}>
          <Button className="w-sm-100" type="submit">
            {t("performanceReview.submit")}
          </Button>
          <Button
            className="w-sm-100"
            borderedSecondary
            type="button"
            onClick={handleCancel}
          >
            {t("performanceReview.cancel")}
          </Button>
        </div>
      )}
    </form>
  );
}
